export default "__VITE_ASSET__a8138c98__"